export const tableHeaders = {
    branchCode: 'Code',
    branchName: 'Branch Name',
    address: 'Address',
    city: 'City',
    state: 'State',
    pincode: 'PIN Code',
    gstNo: 'GST No',
    panNo: 'PAN No',
    service_category : "Service Category",
    cost_center : "Cost Center",
    createdBy: 'Created By',
    createdOn: 'Last Create Date',
    updatedBy: 'Updated By',
    updatedOn: 'Updated Date',
    actions: 'Edit/Delete'
}
export const branchFields = {
    branch_code : {
        title : "Branch Code",
        placeholder : "Branch Code"
    },
    branch_name : {
        title :"Branch Name",
        placeholder: "Branch Name"
    },
    address : {
        title : "Address",
        placeholder : "Address"
    },
    pan_no : {
        title : "PAN Number",
        placeholder :"PAN Number"
    },
    city : {
        title : "City",
        placeholder :"Select City",
    },
    state : {
        title : "State",
        placeholder:"State"
    },
    pincode : {
        title : "Pincode",
        placeholder : "Pincode"
    },
    is_gst_applicable : {
        title : "Is GST Applicable"
    },
    is_gst_exempted:{
        title: "Is GST Exempted"
    },
    gst_no : {
        title:"GST Number",
        placeholder:"GST Number"
    },
    charge_mechanism : {
        title : "Charge Mechanism",
        placeholder :"Select Charge Mechanism"
    },
    start_date:{
        title:"Validity Start Date"
    },
    end_date:{
        title:"Validity End Date"
    },
    exempted_reason:{
        title : "Gst exempted reason",
        placeholder:"--SELECT A REASON--"
    },
    gst_title : "GST Details",
    service_category_title : "Service Category Details",
    service_category : {
        title : "Service Category",
        placeholder:"Select Service Category"
    },
    cost_center : {
        title : "Cost Center",
        placeholder:"Cost Center"
    }
}

export const buttons = {
    cancel : "Cancel",
    submit : "Submit"
}